var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.items),function(item,index){return _c('div',{key:index,staticClass:"score-card-list-table"},[_c('score-card',{attrs:{"item":item,"type":_vm.type,"type-name":_vm.typeName},on:{"fetch":_vm.fetch}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }